import React from 'react'
import { Container } from './Radio.styles'

export interface RadioProps {
	size?: 'small' | 'medium' | 'large'
	label?: string
	id?: string
	name?: string
	checked: boolean
	value: string
	error?: boolean
	disabled?: boolean
	variant?: 'primary' | 'secondary'
	onChange?: (
		checkedState: boolean,
		event?: React.MouseEvent<HTMLDivElement> | undefined,
	) => void
}

export const Radio = ({
	id,
	label,
	size,
	name,
	checked,
	value,
	variant,
	error,
	disabled,
	onChange,
}: RadioProps): JSX.Element => {
	const [isChecked, setChecked] = React.useState<boolean>(false)

	const handleCheck = (event: React.MouseEvent<HTMLDivElement> | undefined) => {
		event && event.preventDefault()
		if (!isChecked && !disabled) {
			setChecked(prev => !prev)
			if (onChange) {
				onChange(!isChecked, event)
			}
		}
	}

	React.useEffect(() => {
		setChecked(checked || false)
	}, [checked])

	return (
		<Container
			data-testid="radio-form"
			variant={variant || 'primary'}
			isActive={isChecked}
			disabled={Boolean(disabled)}
			size={size || 'medium'}
			error={error}
			onClick={(event: React.MouseEvent<HTMLDivElement> | undefined) =>
				handleCheck(event)
			}
			id={id}
		>
			<input
				type="radio"
				name={name}
				id={`input-${id}`}
				checked={checked}
				value={value}
			/>
			<label className="radio-label-before" htmlFor={`input-${id}`}>
				{label}
				<div className="container-radio">
					<div className="checked" />
				</div>
			</label>
		</Container>
	)
}
